module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTc2OCA5NmE2NCA2NCAwIDAgMSA2NCA2NHY3MjAuN2EzMiAzMiAwIDAgMS00My45IDI5LjdMNTEyIDgwMGwtMjc2LjEgMTEwLjRBMzIgMzIgMCAwIDEgMTkyIDg4MC43VjE2MGE2NCA2NCAwIDAgMSA2NC02NGg1MTJ6IG0tMTI4IDE2MGgtMjU2YTMyIDMyIDAgMCAwLTMuNyA2My44TDM4NCAzMjBoMjU2YTMyIDMyIDAgMCAwIDMuNy02My44TDY0MCAyNTZ6IiBmaWxsPSIjMCIgcC1pZD0iMzM1OSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Bookmark-filled.svg
// module id = 1Qwq
// module chunks = 73